import $ from "jquery";
import Column from "../../apis/Column";
import User from "../../apis/User";


export const getAllColumn = ({ commit, dispatch, rootState }, { pageParam, type }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    var allColumn;

    return Column.list(pageParam, rootState.column.searchQuery).then(async response => {

        if (response != '') {

            allColumn = response.data.data;

            for (const column of allColumn) {

                if (column.target_ids != null) {

                    column.target_user = [];

                    for (const targetId of column.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await column.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_COLUMN', allColumn);

            commit('SET_PAGINATION', response.data);

            console.log(response.data);
            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    }).catch((error) => {
    }).finally(() => {
        dispatch('common/setSpinnerStatus', false, { root: true })

    });

}

export const viewColumn = ({ commit, dispatch, rootState }, id) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    return Column.show(id).then(async response => {

        
        var column = response.data.data;

        if (column.target_ids != null) {

            column.target_user = [];

            for (const targetId of column.target_ids) {


                await User.show(targetId).then(async response => {

                    if (response != '') {

                        await column.target_user.push(response.data.data);

                    }

                });

            }

        }

        commit('SET_COLUMN',column);


    })

        .catch(() => { })

        .finally(() => {
            dispatch('common/setSpinnerStatus', false, { root: true })
        });
}

export const deleteColumn = ({ commit, dispatch, rootState }, id) => {

    dispatch('common/setSpinnerStatus', true, { root: true });


    return Column.delete(id).then(

        (response) => {

            if (response != '') {

                commit('DELETE_COLUMN', id);

                $(".bulktool").removeClass("open");

                $(".command_wrap_inbox").removeClass("hide");

                $(".modal").removeClass("open");


                return dispatch('common/setSucccessMessageStatus', {

                    status: true,
                    message: "コラムが正常に削除されました。",

                }, { root: true });

            }
        },

        (error) => {

            console.log(error);
        }
    )

        .catch(() => { })

        .finally(() => {

            return dispatch('common/setSpinnerStatus', false, { root: true });

        });
}

export const setDeleteId = ({ commit, dispatch, rootState }, id) => {

    commit('SET_DELETE_COLUMN_ID', id);

}

export const setFileterStatus = ({ commit, dispatch, rootState }, { papeParam, status }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    let searchStatus = "";

    if (status != "")

        searchStatus = "&where=status@" + `${status}`;

       
    commit('SET_SEARCH_QUERY', searchStatus);


    return Column.filter(papeParam, searchStatus).then(async response => {

        var allColumn;

        if (response != '') {
           
            allColumn = response.data.data;

            for (const column of allColumn) {

                if (column.target_ids != null) {

                    column.target_user = [];

                    for (const targetId of column.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await column.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_COLUMN', allColumn);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    })
        .catch(() => { })

        .finally(() => {

            setTimeout(() => {

                dispatch('common/setSpinnerStatus', false, { root: true })

            }, 10000);
        });

}

export const getSearchData = ({ commit, dispatch, rootState }, { papeParam, searchTerms }) => {


    dispatch('common/setSpinnerStatus', true, { root: true })

    let statusQuery = "&where=status@" + `${searchTerms.status}`;

    let dateQuery = "";

    if (searchTerms.published_start != "") {

        dateQuery = "&datetime=published_at@gte," + `${searchTerms.published_start}T00:00:00`;

    }

    if (searchTerms.published_end != "") {

        dateQuery = "&datetime=published_at@lte," + `${searchTerms.published_end}T23:59:59`;

    }

    if (searchTerms.published_end != "" && searchTerms.published_start != "") {

        dateQuery = "&datetime=published_at@between," + `${searchTerms.published_start}T00:00:00/` + `${searchTerms.published_end}T23:59:59`;

    }

    commit('SET_SEARCH_QUERY', statusQuery + dateQuery);


    return Column.search(papeParam, statusQuery + dateQuery).then(async response => {


        var allColumn;

        if (response != '') {

            allColumn = response.data.data;

            for (const column of allColumn) {

                if (column.target_ids != null) {

                    column.target_user = [];

                    for (const targetId of column.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await column.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_COLUMN', allColumn);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    })
        .catch(() => { })

        .finally(() => {

            dispatch('common/setSpinnerStatus', false, { root: true })

        });

}

export const inputSearchData = ({ commit, dispatch, rootState }, { pageParam, searchTerms }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    commit('SET_SEARCH_QUERY', "&keyword=title,content@" + `${searchTerms}`);

    return Column.inpuSearch(pageParam, searchTerms).then(async response => {

        var allColumn;

        if (response != '') {

            allColumn = response.data.data;

            for (const column of allColumn) {

                if (column.target_ids != null) {

                    column.target_user = [];

                    for (const targetId of column.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await column.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_COLUMN', allColumn);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }

    })
        .catch(() => { })

        .finally(() => {
            dispatch('common/setSpinnerStatus', false, { root: true })

        });

}

